export default SCENE
